import { render, staticRenderFns } from "./aicenter.vue?vue&type=template&id=f6e07a84&scoped=true"
var script = {}
import style0 from "./aicenter.vue?vue&type=style&index=0&id=f6e07a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e07a84",
  null
  
)

export default component.exports